import React from 'react';
import Navbar from '../../components/Navbar';
import SegmAnnoLabelEdit from '../../components/SegmAnnoLabel/SegmAnnoLabelEdit';
import './SegmAnnoLabelEditPage.css';

const SegmAnnoLabelEditPage = () => {
  return (
    <div className="segm-anno-label-edit-page">
      <Navbar />
      <div className="segm-anno-label-edit-content">
        <SegmAnnoLabelEdit />
      </div>
    </div>
  );
};

export default SegmAnnoLabelEditPage;
